"use client";

var __jsx = React.createElement;
import React, { useState, useRef, useEffect } from "react";
import Icons from "@modules/icons";
export const GenericSelectInput = _ref => {
  let {
    label,
    value,
    options,
    placeholder,
    onSelect
  } = _ref;
  const {
    0: isOpen,
    1: setIsOpen
  } = useState(false);
  const containerRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const selectedOption = options.find(option => option.value === value);
  const displayValue = selectedOption ? selectedOption.value.toString() : placeholder;
  const handleSelect = option => {
    onSelect(option.value);
    setIsOpen(false);
  };
  return __jsx("div", {
    className: "flex flex-row items-center justify-between border-[0.5px] border-globals-input_border rounded-lg w-full p-2 cursor-pointer",
    ref: containerRef,
    onClick: () => setIsOpen(!isOpen)
  }, __jsx("div", {
    className: "flex flex-col"
  }, __jsx("p", {
    className: "tx-psm-semiBold text-primary_text"
  }, label), __jsx("div", {
    className: "relative"
  }, __jsx("div", {
    className: "w-full flex items-center justify-between text-left bg-white"
  }, __jsx("span", {
    className: value !== undefined ? "text-primary_text tx-psm-semiBold" : "text-gray-500"
  }, displayValue)), isOpen && __jsx("div", {
    className: "absolute z-10 left-0 right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto w-[420px] md:w-[240px]"
  }, options.map(option => __jsx("button", {
    key: option.key,
    type: "button",
    className: "w-full px-4 py-2 text-left text-primary_text hover:bg-gray-100 focus:bg-gray-100 focus:outline-none ".concat(value === option.value ? 'bg-blue-50 text-blue-600' : ''),
    onClick: e => {
      e.stopPropagation();
      handleSelect(option);
    }
  }, option.value))))), __jsx(Icons.chevronDown, {
    className: "transform transition-transform ".concat(isOpen ? "rotate-180" : ""),
    size: 20
  }));
};